//@ts-nocheck
import React, { ReactElement } from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { get } from 'lodash'
import PageLoadingInterstitial from 'components/shared/interstitials/PageLoadingInterstitial'

const referralStatus = gql`
	query referralStatus($email: String!) {
		subscriber(email: $email) {
			id
			numReferred
			referralLink
		}
	}
`;

interface Props {
    email: string,
    children: ({ subscriber }) => ReactElement
}

class NewsletterReferralStatusQuery extends React.Component<Props> {

    parseData = data => ({
        subscriber: get(data, 'subscriber', {})
    })

    render() {
        const { email } = this.props
        return (
            <Query query={referralStatus} variables={{ email }}>
                {({ loading, data, error}) => (
                    loading || error
                    ? <PageLoadingInterstitial loading={loading} error={error}/>
                    : this.props.children(this.parseData(data))
                )}
            </Query>
        )
    }
}

export default NewsletterReferralStatusQuery;